import React, {useState, useCallback} from "react";
import { Stack } from "@mui/material";
import {isApolloError} from "@apollo/client";
import { isNetworkConnectionError, isServerError} from "~/apollo/errors";
import {ErrorHandlerProvider} from "~/components/ErrorHandling/context";
import {makeStyles} from "@mui/styles";
import {PortTheme} from "~/ui/theme";
import {PopupMessage} from "~/components/PopupMessage";


export type ErrorMessage = {
    title: string
    message: string
}

export const AlertErrorHandlerProvider = ({children}) => {
    const [errors, setErrors] = useState<ErrorMessage[]>([]);

    const handleErrorClose = (error: ErrorMessage, e) => {
        setErrors(errors => errors.filter(x => x != error))
    }

    const handleError = useCallback((error: Error) => {
        if (!(error instanceof Error)) {
            return;
        }
        let message: ErrorMessage;

        if (isNetworkConnectionError(error)) {
            message = {title: "Сервер не доступен", message: "Проверьте соединение с интернетом."};
        } else if (isServerError(error)) {
            // @ts-ignore
            const content = typeof error.networkError.result == "string" ? error.networkError.result : JSON.stringify(error.networkError.result);
            message = {
                title: "Ошибка сервера",
                // @ts-ignore
                message: `URL: ${error.networkError.response.url}\nResponse: [${error.networkError.response.status}] ${error.networkError.response.statusText}\n${content}`
            }
        } else if (isApolloError(error) && error.graphQLErrors?.length) {
            message = {
                title: "Ошибка запроса",
                message: error.graphQLErrors.map(error => error.extensions?.message || error.message).join(". ")
            }
        }

        if (message) {
            setErrors(errors => {
                for (const error of errors) {
                    if (JSON.stringify(error) == JSON.stringify(message)) {
                        return errors;
                    }
                }
                return errors.concat([message]);
            });
        }
        console.group("ErrorHandler");
        console.error(error);
        console.groupEnd();
    }, [setErrors]);

    return (
        <ErrorHandlerProvider value={handleError}>
            {children}

            {errors.length > 0 && (
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={1}
                    padding="16px"
                    position="fixed"
                    bottom={0}
                    left={0}
                    right={0}
                    zIndex={10010}
                >
                    {errors.map((notification, index) => (
                        <PopupMessage onClose={handleErrorClose} open={true} notification={notification} key={index} />
                    ))}
                </Stack>
            )}
        </ErrorHandlerProvider>
    );
}
